// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import {
  removeSensitiveData,
  BASE_CONFIG,
  CLIENT_EXCEPTIONS_TO_IGNORE,
} from './src/observability/sentry';

Sentry.init({
  ...BASE_CONFIG,
  ignoreErrors: CLIENT_EXCEPTIONS_TO_IGNORE,
  beforeSend(event) {
    if (event.environment === 'development') {
      console.log(
        'Would have sent the following exception to Sentry: ',
        JSON.stringify(event.exception?.values),
      );
      return null;
    }

    removeSensitiveData(event);

    return event;
  },
});
